module.exports = __webpack_public_path__ + "img/file-attachment-04.fddfcd2c.svg";